import { CloseButton, OverlayTrigger, Tooltip } from "react-bootstrap";
import type { CaseFileLite } from "@/briefpoint-client";
import styles from "./FileList.module.scss";

interface Props {
  files: CaseFileLite[];
  canRemove?: (file: CaseFileLite) => boolean;
  onRemove: (file: CaseFileLite) => void;
  /** when true, remove button is disabled (e.g. while upload is in progress) */
  disableRemove?: boolean;
}

export default function FileList(props: Props) {
  return (
    <div className={styles.fileList}>
      {props.files.map((file) => {
        const showRemove =
          props.canRemove === undefined || props.canRemove(file);
        return (
          <div key={file.id} className={styles.fileItemContainer}>
            <div
              data-testid="production-file-item"
              className="d-flex justify-content-between p-1 align-items-center"
            >
              <div
                data-testid="production-file-name"
                className={`${styles.fileItemName} ms-2`}
              >
                {file.name}
              </div>
              {showRemove && (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip data-testid="remove-production-tooltip">
                      <div className="text-center">
                        {props.disableRemove
                          ? "Remove disabled while uploading"
                          : "Remove"}
                      </div>
                    </Tooltip>
                  }
                >
                  <span
                    className={
                      props.disableRemove
                        ? styles.removeButtonDisabled
                        : undefined
                    }
                  >
                    <CloseButton
                      data-testid="remove-production-button"
                      className={`${styles.closeButton} me-2`}
                      onClick={() =>
                        !props.disableRemove && props.onRemove(file)
                      }
                    />
                  </span>
                </OverlayTrigger>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
